var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.368,
    height: 33.21,
    viewBox: "0 0 20.368 33.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(0.515 0.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_24",
    "data-name": "Union 24",
    d: "M11733.308,9291.452a2.12,2.12,0,0,1-1.5-2.335,6.884,6.884,0,0,0-1.907-5.514,5.25,5.25,0,0,1-1.317-3.517,2.609,2.609,0,0,1,1.716-2.655c.389-.15.427-.359.427-.7q-.009-3.833,0-7.663a4.525,4.525,0,0,1,.077-.935,2.132,2.132,0,0,1,4.186.112,7.585,7.585,0,0,1,.059,1.126c.006.875,0,1.75,0,2.688a2.3,2.3,0,0,1,3.112,1.138,2.251,2.251,0,0,1,3.375,1.8c1.7.48,2.2,1.064,2.086,2.812a49.9,49.9,0,0,1-.615,5.671,26.118,26.118,0,0,0-.41,5.68,2.154,2.154,0,0,1-1.5,2.29,11.029,11.029,0,0,1-3.9.731A10.917,10.917,0,0,1,11733.308,9291.452Zm-3.64-11.557a4.657,4.657,0,0,0,1.082,3.074c.247.31.516.6.757.922a7.5,7.5,0,0,1,1.362,5.226,1.21,1.21,0,0,0,.869,1.354,9.866,9.866,0,0,0,6.938-.018,1.189,1.189,0,0,0,.837-1.306,26.7,26.7,0,0,1,.372-5.559c.351-2.014.486-4.064.675-6.1.073-.825-.277-1.2-1.034-1.255-.019.309-.036.615-.054.948h-1.055c0-.684.009-1.329-.006-1.975a1.078,1.078,0,0,0-1.076-1.2,1.113,1.113,0,0,0-1.072,1.223c-.009.286,0,.572,0,.894h-1.064v-1.586c0-1.084-.336-1.592-1.061-1.606-.749-.015-1.091.5-1.091,1.63v1.542h-1.088v-2.629c0-1.609.012-3.222-.009-4.834a1.061,1.061,0,0,0-1.055-1.1,1.08,1.08,0,0,0-1.079,1.076c-.012.188,0,.377,0,.565v11.238h-1.091v-2.007A1.593,1.593,0,0,0,11729.668,9279.9Zm-4.459-15.2a8.6,8.6,0,0,1,15.947,6.192c-.3-.083-.609-.165-.973-.266a7.716,7.716,0,0,0-1.185-6.4,7.4,7.4,0,0,0-3.84-2.794,7.508,7.508,0,0,0-8.441,2.862,7.32,7.32,0,0,0-1.312,5.172,7.642,7.642,0,0,0,2.44,4.771c-.233.263-.442.5-.646.723C11724.911,9273.314,11723.1,9268.843,11725.209,9264.693Z",
    transform: "translate(-11724.276 -9260)",
    fill: "#2d335d",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointOut);
export default __webpack_public_path__ + "static/media/point-out.8a77e642b69c11f3735b86cf4e6f01f1.svg";
export { ForwardRef as ReactComponent };